import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload.service';
import { DataSourceService } from '../../../services/data-source.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog, MatTabChangeEvent, MatSelectChange } from '@angular/material';
import { LogicService } from '../../../services/logic.service';
import { PeriodTypeEnum, PayrollParameters, Employee, CompanyRef, Parameter } from '@akiba/models_bimbo';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-payroll-dates',
  templateUrl: './payroll-dates.component.html',
  styleUrls: ['./payroll-dates.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PayrollDatesComponent implements OnInit, OnDestroy {

  parameterSubscription: Subscription = null;
  payrollParameters: Array<PayrollParameters> = new Array<PayrollParameters>();
  modPayrollParameter: PayrollParameters | null = null;
  companies: Array<CompanyRef> = new Array<CompanyRef>();

  @ViewChild('name', { static: false }) name: FormControl;
  selectedIndex = 0;
  savingTypes = [{ type: 2, typeString: 'Permanente' }, { type: 3, typeString: 'Retiro' }];
  wageTypes = [{ type: 2, typeString: 'PR' }, { type: 3, typeString: 'QU' }, { type: 2, typeString: 'VE' }];
  tempWage: any | null = null;
  editWage: any | null = null;
  savingType: any | null = null;
  showWageTypes = true;
  isEdit = false;
  isNew = false;
  contentLocation: AppState = new AppState();
  uploadSubscription: Subscription = null;

  constructor(public authService: AuthenticationService, private uploadService: UploadService, private dataService: DataSourceService, public dialog: MatDialog, public logicService: LogicService) {

    this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

      if (p && p.response) {
        this.payrollParameters = this.logicService.dataManager.parameterDataLoader.payrolls ? this.logicService.dataManager.parameterDataLoader.payrolls : [];
      }

    });

    this.logicService.dataManager.parameterDataLoader.load();


  }


  ngOnInit() {
  }

  ngOnDestroy(): void {

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
  }

  selectedTypeChange(event: MatSelectChange) {
    this.modPayrollParameter = new PayrollParameters();
    if (!event.value) {
      this.isEdit = false;
      this.isNew = false;
      this.tempWage = null;
      this.editWage = null;
      this.savingType = null;
      this.showWageTypes = true;
      if (this.name) {
        this.name.reset();
      }
    } else {
      this.isEdit = false;
      this.isNew = false;
      this.editWage = null;
      this.savingType = event.value;
      this.showWageTypes = true;
      this.tempWage = event.value;
    }

  }

  keyUpMethod(event: string) {
    if (event) {
      this.isEdit = false;
      this.isNew = true;
      this.editWage = null;
    } else {
      this.isEdit = false;
      this.isNew = false;
      this.tempWage = null;
      this.editWage = null;
      this.contentLocation.savingParametersIndex = 0;
    }
  }

  editSelectedTypeChange(event: MatSelectChange) {
    this.modPayrollParameter = new PayrollParameters();
    this.savingType = null;
    
    if (!event.value) {
      this.isEdit = false;
      this.isNew = false;
      this.tempWage = null;
      this.editWage = null;
    } else {
      this.isEdit = true;
      this.isNew = false;
      this.tempWage = null;
      const obj = event.value.toAny();
      this.contentLocation.savingParametersIndex = 0;
      this.modPayrollParameter = new PayrollParameters(obj);
      this.editWage = event.value;

    }

  }

  savePeriod() {

    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;

    if (!this.savingType && !this.isEdit) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El tipo del caja es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.savingType) {
      this.modPayrollParameter.payrollType = this.savingType.typeString;
    }

    if (!this.isEdit && this.isNew) {

      const id = new Date().getTime().toString();
      this.modPayrollParameter.payrollParametersID = this.modPayrollParameter.payrollParametersID == '' ? id : this.modPayrollParameter.payrollParametersID ;
      this.modPayrollParameter.payrollType = this.tempWage.typeString;
    }

    if (!this.modPayrollParameter.title) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El nombre del ciclo es requerido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modPayrollParameter.payrollDates.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que se añada al menos una fecha de pago.',
          close: 'Aceptar'
        }
      });
      return;

    }

    if (!this.modPayrollParameter.includedCompanies.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que se seleccione al menos una compañía.',
          close: 'Aceptar'
        }
      });
      return;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información dada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(result => {

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'payroll',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };

        this.modPayrollParameter.payrollDates.map(element => {
          const startMoment = moment(element.startDate);
         // const endMoment = moment(element.endDate);
          element.startDate = startMoment.startOf('day').toDate();
          element.endDate = startMoment.endOf('day').toDate();

      });

      this.modPayrollParameter.payrollDatesForLoans.map(element => {
        const startMoment = moment(element.startDate);
        const endMoment = moment(element.endDate);

        element.startDate = startMoment.startOf('day').toDate();
        element.endDate = endMoment.startOf('day').toDate();

    });

        if (this.modPayrollParameter.fileUploaded.file) {

          this.uploadService.pushUpload(this.modPayrollParameter.fileUploaded);
          this.uploadSubscription = this.uploadService.downloadURLSubject.subscribe(downloadURL => {

            this.modPayrollParameter.fileUploaded.file = null;
            this.modPayrollParameter.fileUploaded.downloadURL = downloadURL;
            if (this.uploadSubscription && !this.uploadSubscription.closed) {
              this.uploadSubscription.unsubscribe();
              this.uploadSubscription = null;
            }
            const aPeriodObj = this.modPayrollParameter.toAny();

            this.dataService.savePayroll(aPeriodObj).then(() => {
              paramLogs.changeID = aPeriodObj.payrollParametersID;
              this.dataService.saveLogAdministratorActions(paramLogs ,'payrollDatesFileUploaded');
              this.contentLocation.savingParametersIndex = 0;
              this.reset();
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'La información ha sido actualizada',
                  close: 'Aceptar'
                }
              });

            });

          });

        } else {

          const aPeriodObj = this.modPayrollParameter.toAny();
          paramLogs.changeID = aPeriodObj.payrollParametersID;
          this.dataService.saveLogAdministratorActions(paramLogs ,'payrollDates');
          this.dataService.savePayroll(aPeriodObj).then(() => {
            this.contentLocation.savingParametersIndex = 0;
            this.reset();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada',
                close: 'Aceptar'
              }
            });

          }).catch(error => {
            console.log(error);
          });

        }

      }
    });

  }

  cancelPeriodChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.reset();
      }
    });


  }

  reset() {
    this.modPayrollParameter = new PayrollParameters();
    this.selectedIndex = 0;
    this.contentLocation.savingParametersIndex = 0;
    this.isEdit = false;
    this.isNew = false;
    this.tempWage = null;
    this.editWage = null;
    this.savingType = null;
    this.showWageTypes = true;

  }

}
